import EmptyState from '@Guidelines/Component/EmptyState';
import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
import buildSubjectPath from '@UI/Pages/Beneficiaries/Shared/Helpers/buildSubjectPath';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@verclam/ui-kit';

type Props = {
	readonly subject: SubjectAddress;
	readonly title: string;
	readonly description?: string;
	readonly icon: React.ReactNode;
	/** Offers the way back to the dossier; off when the page will move on by itself. */
	readonly canReturn: boolean;
};

/** Every "nothing to do here" outcome of the page, with an optional way back to the dossier. */
const UploadEmptyState: React.FC<Props> = ({ subject, title, description, icon, canReturn }) => {
	const navigate = useNavigate();

	const handleReturn = React.useCallback(() => {
		navigate(buildSubjectPath(subject));
	}, [navigate, subject]);

	return (
		<EmptyState
			title={title}
			description={description}
			icon={icon}
			action={
				<ConditionalLoader data={canReturn}>
					<Button type="button" label="Revenir au dossier" onClick={handleReturn} />
				</ConditionalLoader>
			}
		/>
	);
};

export default UploadEmptyState;
